<template>
    <div id="map" />
</template>
<script>
    import {Loader} from "@googlemaps/js-api-loader";
    export default {
        props: {
            start: Object,
            end: Object,
            serviceAddress: Object,
            evvRadius: {
                type: Number,
                default: 300,
            },
            logs: {
                type: Array,
                default: () => {
                    return []
                },
            },
        },

        computed: {
            mapCenter() {
                return {
                    lat: parseFloat(this.serviceAddress.latitude),
                    lng: parseFloat(this.serviceAddress.longitude),
                };
            },
        },

        async mounted() {
            const loader = new Loader({
                apiKey: window.gmapsKey,
                version: "weekly",
            });

            const { Map, Circle } = await loader.importLibrary('maps');
            const { AdvancedMarkerElement } = await loader.importLibrary('marker');

            const map = new Map(document.getElementById("map"), {
                center: this.mapCenter,
                zoom: 15,
                mapId: window.gmapsMapId,
            });

            const radiusCircle = new Circle({
                strokeColor: "#1d4ed8",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#93c5fd",
                fillOpacity: 0.35,
                map,
                center: this.mapCenter,
                radius: this.evvRadius,
            });

            for (let i = 0; i < this.logs.length; i++) {
                const log = this.logs[i];
                const logPin = new AdvancedMarkerElement({
                    position: {
                        lat: parseFloat(log.latitude),
                        lng: parseFloat(log.longitude),
                    },
                    map,
                    title: "Log Location",
                    content: this.makePinElement(i + 1, 'yellow'),
                });
            }

            if (this.start.latitude && this.start.longitude) {
                const startPin = new AdvancedMarkerElement({
                    position: {
                        lat: parseFloat(this.start.latitude),
                        lng: parseFloat(this.start.longitude),
                    },
                    map,
                    title: "Check in Location",
                    content: this.makePinElement('I', 'red'),
                });
            }

            if (this.end.latitude && this.end.longitude) {
                const endPin = new AdvancedMarkerElement({
                    position: {
                        lat: parseFloat(this.end.latitude),
                        lng: parseFloat(this.end.longitude),
                    },
                    map,
                    title: "Check out Location",
                    content: this.makePinElement('O', 'red'),
                });
            }

            const serviceAddressPin = new AdvancedMarkerElement({
                position: this.mapCenter,
                map,
                title: "Client Location",
                content: this.makePinElement('H', 'orange'),
            });
        },

        methods: {
            makePinElement(content, className) {
                const pinElement = document.createElement("div");
                pinElement.className = `pin ${className}`;
                pinElement.textContent = content;
                return pinElement;
            },
        },
    }
</script>
<style>
#map {
  overflow:hidden;
}
.yellow {
    background-color: #fde047;
    color: #000;
}
.yellow:after {
    border-top: 8px solid #fde047;
}
.red {
    background-color: #dc2626;
    color: #fff;
}
.red:after {
    border-top: 8px solid #dc2626;
}

.orange {
    background-color: #f97316;
    color: #fff;
}
.orange:after {
    border-top: 8px solid #f97316;
}

.pin {
    //background-color: #dc2626;
    //color: #fff;
    border-radius: 12px;
    font-size: 18px;
    padding: 8px 12px;
    position: relative;
    min-width: 40px;
    text-align: center;
}
.pin:after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    //border-top: 8px solid #dc2626;
    content: "";
    height: 0;
    left: 50%;
    position: absolute;
    top: 100%;
    transform: translate(-50%);
    width: 0;
}

.service-address {
    background-color: #4285f4;
    color: #fff;
}

div#map.shift-map div div.gm-style div div canvas {
  background: transparent !important;
  max-height: fit-content;
  max-width: fit-content;

}
</style>
